export default __webpack_public_path__ + "static/media/ptv.1ddef244.png";